// Foundations
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

// Models
import { LoadingIndicatorData } from '../models/loading-indicator-data.model';

// Components
import { LoadingIndicatorDialogComponent } from '../components/_share/loading-indicator-dialog/loading-indicator-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingIndicatorService {

  dialogRef: MatDialogRef<LoadingIndicatorDialogComponent>;
  showed = false;

  constructor(
    private dialog: MatDialog
  ) { }

  show(data?: LoadingIndicatorData): void {
    if (!this.showed) {
      this.showed = true;
      //
      this.dialogRef = this.dialog.open(LoadingIndicatorDialogComponent, {
        panelClass: 'loading-indicator-dialog',
        disableClose: true,
        data
      });
    }
  }

  hide(): void {
    this.showed = false;
    this.dialogRef.close();
  }
}
